import React, { useEffect, useState } from "react";
// 引入整合后的 Less 样式
import "./TowerEffect.less";

// 导入塔板背景图片（替换为实际项目路径）
import towerImage from "@/assets/xdt2.png";

const TowerEffect = (props: any) => {
  const {
    currentMode,
    currentData,
    setCurrentData,
    currentModeData,
    wrapWidth = 250,
    imageStyle = null,
    trayHeight = 350,
    trayContainerStyle = {
      top: 60,
      left: 29,
      width: 53,
    },
    unit = "", // 新增的单位属性
  } = props;
  
  const [curColors, setCurColors] = useState<any>(null); // 当前热力图色谱

  // 数据变化时重新计算颜色
  useEffect(() => {
    if (currentModeData && Array.isArray(currentModeData) && currentModeData.length > 0) {
      setCurColors(buildeColors());
    }
  }, [currentModeData]);

  // 创建颜色块（核心逻辑保留）
  const buildeColors = () => {
    if (!currentModeData || currentModeData.length === 0) return [];
    
    const min = Math.min(...currentModeData);
    const max = Math.max(...currentModeData);

    // 为每个数据点创建颜色块
    return currentModeData.map((value: number) => {
      const normalizedValue = (value - min) / (max - min);
      const color = getColor(normalizedValue);
      return color;
    });
  };

  // 根据值获取颜色 - 5色系渐变（蓝色→青色→绿色→黄色→红色）
  const getColor = (value: number) => {
    // 确保value在[0,1]范围内
    const clampedValue = Math.max(0, Math.min(1, value));

    // 定义5个颜色节点
    const colors = [
      { r: 0, g: 0, b: 255 }, // 蓝色 (0.0)
      { r: 0, g: 255, b: 255 }, // 青色 (0.25)
      { r: 0, g: 255, b: 0 }, // 绿色 (0.5)
      { r: 255, g: 255, b: 0 }, // 黄色 (0.75)
      { r: 255, g: 0, b: 0 }, // 红色 (1.0)
    ];

    // 计算在5个颜色之间的位置
    const position = clampedValue * 4; // 映射到0-4范围
    const index = Math.floor(position);
    const remainder = position - index;

    // 安全检查
    if (!colors || index < 0 || index >= colors.length) {
      return "rgba(128, 128, 128, 0.6)"; // 灰色默认值
    }

    // 恰好是颜色节点
    if (remainder === 0) {
      const color = colors[index];
      if (color && typeof color.r === "number" && typeof color.g === "number" && typeof color.b === "number") {
        return `rgba(${color.r}, ${color.g}, ${color.b}, 0.6)`;
      }
      return "rgba(128, 128, 128, 0.6)";
    }

    // 线性插值计算渐变颜色
    const fromColor = colors[index];
    const toColor = colors[index + 1];

    if (!fromColor || !toColor || 
        typeof fromColor.r !== "number" || typeof fromColor.g !== "number" || typeof fromColor.b !== "number" ||
        typeof toColor.r !== "number" || typeof toColor.g !== "number" || typeof toColor.b !== "number") {
      const fallbackColor = colors[Math.min(index, colors.length - 1)];
      if (fallbackColor && typeof fallbackColor.r === "number" && typeof fallbackColor.g === "number" && typeof fallbackColor.b === "number") {
        return `rgba(${fallbackColor.r}, ${fallbackColor.g}, ${fallbackColor.b}, 0.6)`;
      }
      return "rgba(128, 128, 128, 0.6)";
    }

    const r = Math.round(fromColor.r + (toColor.r - fromColor.r) * remainder);
    const g = Math.round(fromColor.g + (toColor.g - fromColor.g) * remainder);
    const b = Math.round(fromColor.b + (toColor.b - fromColor.b) * remainder);

    return `rgba(${r}, ${g}, ${b}, 0.6)`;
  };

  // 获取图例最大值（逻辑保留）
  const getMaxValue = () => {
    if (!currentModeData || currentModeData.length === 0) return 0;
    const max = Math.max(...currentModeData);
    if (max > 0 && max < 1) {
      return 1;
    } else {
      return parseInt(String(max + 1));
    }
  };

  // 获取图例最小值（更新后的逻辑：min >= 0 时返回 0）
  const getMinValue = () => {
    if (!currentModeData || currentModeData.length === 0) return 0;
    const min = Math.min(...currentModeData);
    if (min >= 0 && min < 1) { // 修改后的判断条件
      return 0;
    } else {
      return parseInt(String(min - 1));
    }
  };

  // 计算塔板项高度
  const getTrayItemHeight = (index: number) => {
    if (!currentModeData || currentModeData.length === 0) return 0;
    return currentData === index 
      ? trayHeight / currentModeData.length + 10 
      : trayHeight / currentModeData.length;
  };

  return (
    <div className="tower-effect-container" style={{ width: `${wrapWidth}px` }}>
      {/* 图片容器 */}
      <div className="img-container">
        {/* 塔板背景图 */}
        <div className="logo-img">
          <img 
            src={towerImage} 
            alt="塔板示意图" 
            style={imageStyle || { height: '400px', width: '70px' }} 
          />
        </div>
        
        {/* 塔板热力图容器 */}
        <div 
          className="tray-container"
          style={{
            ...trayContainerStyle,
            height: `${trayHeight}px`,
            top: `${trayContainerStyle.top}px`,
            left: `${trayContainerStyle.left}px`,
            width: `${trayContainerStyle.width}px`
          }}
        >
          {currentModeData && curColors && currentModeData.map((_: any, index: number) => (
            <button
              key={index}
              className="tray-item"
              style={{
                backgroundColor: currentData === index ? "rgb(0,0,0)" : curColors[index] || "#ccc",
                height: `${getTrayItemHeight(index)}px`,
                borderWidth: currentData === index ? "1px" : "0",
                borderColor: currentData === index ? "rgb(255,255,255)" : "rgb(0,0,0)",
                borderStyle: "solid"
              }}
              onClick={() => {
                if (setCurrentData) {
                  setCurrentData(index);
                }
              }}
              // 禁用状态（无setCurrentData时）
              // disabled={!setCurrentData}
            >
              {currentData === index && (
                <span className="tray-item-text">{index + 1}</span>
              )}
            </button>
          ))}
        </div>
      </div>
      
      {/* 图例区域（使用传入的unit属性） */}
      <div className="legend-area">
        {/* 最大值 + 单位 */}
        <div className="legend-value max-value">
          <span className="value-number">{getMaxValue()}</span>
          <span className="value-unit">
            {unit}
          </span>
        </div>
        
        {/* 颜色渐变条（替代Expo LinearGradient） */}
        <div className="color-legend">
          <div className="gradient-bar"></div>
        </div>
        
        {/* 最小值 */}
        <div className="legend-value min-value">
          <span>{getMinValue()}</span>
        </div>
      </div>
    </div>
  );
};

export default TowerEffect;